import * as React from "react"
import Svg, { G, Path, Defs } from "react-native-svg"

export default function Clipboard(props) {
    const { color } = props

    return (
<Svg width={34} height={35} xmlns="http://www.w3.org/2000/svg" {...props}>
      <Defs></Defs>
      <G
        transform="translate(-178 -697)"
        filter="url(#prefix__a)"
        fill="none"
        fillRule="evenodd"
      >
        <G stroke="#89C164" strokeWidth={1.8} fillRule="nonzero">
          <Path
            d="M183.989 730.033h-2.503c-.738 0-1.339-.506-1.339-1.128v-28.81c0-.622.601-1.128 1.34-1.128h9.94c.316 0 .573-.217.573-.484s-.257-.483-.574-.483h-9.94c-1.37 0-2.486.94-2.486 2.095v28.81c0 1.155 1.115 2.095 2.486 2.095h2.503c.317 0 .573-.216.573-.483s-.256-.484-.573-.484z"
            fill="#89C164"
          />
          <Path
            d="M209.84 704.813l-7.532-6.671a.58.58 0 00-.386-.142h-6.3c-.301 0-.546.216-.546.483s.245.484.546.484h5.754v4.576c0 1.155 1.06 2.095 2.365 2.095h5.167v23.267c0 .622-.571 1.128-1.273 1.128h-19.09c-.3 0-.545.217-.545.484s.244.483.546.483h19.089c1.304 0 2.365-.94 2.365-2.095v-23.75a.463.463 0 00-.16-.342zm-6.099-.142c-.702 0-1.274-.506-1.274-1.128v-3.893l5.67 5.02h-4.396z"
            fill="#89C164"
          />
          <Path
            d="M205.427 710h-19.854c-.317 0-.573.224-.573.5s.256.5.573.5h19.854c.317 0 .573-.224.573-.5s-.256-.5-.573-.5zM205.427 717h-19.854c-.317 0-.573.224-.573.5s.256.5.573.5h19.854c.317 0 .573-.224.573-.5s-.256-.5-.573-.5zM205.427 724h-19.854c-.317 0-.573.224-.573.5s.256.5.573.5h19.854c.317 0 .573-.224.573-.5s-.256-.5-.573-.5z"
            fill="#89C164"
          />
        </G>
      </G>
    </Svg>
    )
}